import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {LayoutModule} from '../layout/layout.module';
import {CoreModule} from '../core/core.module';
import {MigrationComponentList, MigrationServiceList} from "@ispm/migration/index";
import {ISPMLoginModule} from "@ispm/migration/components/login-component/login.module";
import {ReactiveFormsModule} from "@angular/forms";
import {DlsSharedModule} from "../dls-shared.module";
import { ISPMHomeModule } from './components/home-component/home.module';

@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    SharedModule,
    LayoutModule,
    ISPMLoginModule,
    ISPMHomeModule,
    ReactiveFormsModule,
    DlsSharedModule
  ],
  declarations: [...MigrationComponentList],
  exports: [...MigrationComponentList],
  providers: [...MigrationServiceList
  ]
})
export class MigrationModule {
}
